import React from 'react';
import SectionHeader from './SectionHeader';
import EmptyState from './EmptyState';
import NewUserCard from './NewUserCard';

const NewUsersSection = ({ users, onOpenAll, onOpenUser }) => {
  return (
    <section className="mb-10 md:mb-12">
      <SectionHeader title="새로 가입한 유저" actionLabel="전체 보기" onAction={onOpenAll} />

      {(users || []).length === 0 ? (
        <EmptyState message="표시할 유저가 없습니다." />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {(users || []).slice(0, 12).map((u) => (
            <NewUserCard key={u.id} user={u} onClick={() => onOpenUser(u.id)} />
          ))}
        </div>
      )}
    </section>
  );
};

export default NewUsersSection;
